import { getPortalNamespace, storage } from "../../utils/auth";

function LoginRedirection(res, routevar) {
    if (
      res.data.message ===
      "Token Expired: The authentication token you provided has expired. To continue using our services, please renew your token by following our authentication or login process. If you encounter any issues, feel free to contact our support team for assistance."
    ) {
      const namespace = getPortalNamespace();
      if (namespace) {
        storage.clearNamespace(namespace);
      }
      window.location.href = `${process.env.REACT_APP_LOGIN_REDIRECTION_URL}/${routevar}`;
    }
  }
  
  export default LoginRedirection;
  